import { mapProps } from 'recompose';
import OrdersList from '../components/OrdersList';

const PastOrdersHOC = mapProps(({ pastOrders, ...rest }) => ({
  ...rest,
  orders: pastOrders,
}));

export default PastOrdersHOC(OrdersList);
